// extracted by mini-css-extract-plugin
module.exports = {"river":"river_river__0zTMt"};